import React from 'react';
import { PlusCircle } from 'lucide-react';
import TaskList from './TaskList';

export default function MyTasks({ tasks, navigateTo, currentUser, userRole, deleteTask, batchUpdateStatus, batchAssign, batchArchive }) {
  const mine = tasks.filter(t => t.assignee === currentUser || t.collaborators.includes(currentUser));
  return (
    <TaskList
      tasks={mine}
      navigateTo={navigateTo}
      currentUser={currentUser}
      userRole={userRole}
      deleteTask={deleteTask}
      batchUpdateStatus={batchUpdateStatus}
      batchAssign={batchAssign}
      batchArchive={batchArchive}
      title="我的任务"
    />
  );
}
